import React, {memo} from 'react';

import {
  build12Or24hOptionsForFormat,
  TimeFormatsEnum,
} from '../../../../../libs/shared/core/src/helpers/datetime/dateTimeHelpers';
import {AbsoluteDateTimeFormatter} from '../../../../../libs/shared/ui/src/components/datetime/absoluteDateTimeFormatter';
import {RelativeDateTimeFormatsEnum} from '../../../../../libs/shared/ui/src/components/datetime/relativeDateTimeFormatter';
import {
  DateTimeFormatsEnum,
  DateTimeFormatter,
} from '../../../../../srcCommon/formatters/dateTime/dateTimeFormatter';

/*
 * Props.
 */

interface InvertedDateTimeFormatterProps {
  timeFormat: TimeFormatsEnum;
  format: DateTimeFormatsEnum | undefined;
  value: number;
}

/*
 * Component.
 */

export const InvertedDateTimeFormatter = memo<InvertedDateTimeFormatterProps>((props) => {
  if (props.format === DateTimeFormatsEnum.ABSOLUTE) {
    return (
      <DateTimeFormatter
        value={props.value}
        format={DateTimeFormatsEnum.RELATIVE}
        relativeFormat={RelativeDateTimeFormatsEnum.FULL}
      />
    );
  }

  const format = getFormat(props.timeFormat);

  return (
    <AbsoluteDateTimeFormatter timeFormat={props.timeFormat} value={props.value} customFormat={format} />
  );
});

/*
 * Helpers.
 */

const commonFormat: Intl.DateTimeFormatOptions = {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  minute: 'numeric',
  hour: 'numeric',
};
const h12Format: Intl.DateTimeFormatOptions = {
  ...commonFormat,
  ...build12Or24hOptionsForFormat(TimeFormatsEnum.H12),
};
const h24Format: Intl.DateTimeFormatOptions = {
  ...commonFormat,
  ...build12Or24hOptionsForFormat(TimeFormatsEnum.H24),
};

function getFormat(timeFormat: TimeFormatsEnum) {
  return timeFormat === TimeFormatsEnum.H24 ? h24Format : h12Format;
}
